export const HIDE_ADMIN_FEATURES = 'HIDE_ADMIN_FEATURES';

export function hideAdminFeaturesAction() {
    return {
        type: HIDE_ADMIN_FEATURES
    };
}
